import { render, staticRenderFns } from "./ContainerWrapper.vue?vue&type=template&id=18221c6e&"
import script from "./ContainerWrapper.vue?vue&type=script&lang=js&"
export * from "./ContainerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ContainerWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports